import { gql } from 'urql';

const UPDATE_OPPORTUNITIES_VIEWS = gql`
  mutation UpsertUserOpportunityVisit(
    $objects: [user_opportunity_visit_insert_input!]!
    $update_columns: [user_opportunity_visit_update_column!]!
  ) {
    insert_user_opportunity_visit(
      objects: $objects
      on_conflict: { constraint: user_opportunity_visit_pkey, update_columns: $update_columns }
    ) {
      affected_rows
      returning {
        user_id
        company_id
        teams_id
        opportunity_id
        last_visit_at
      }
    }
  }
`;

export default UPDATE_OPPORTUNITIES_VIEWS;
